
angular.module('app.controllers.footer', []).controller('FooterController', ['$rootScope','$scope','$log', function ($rootScope, $scope, $log ) {
  
  'use strict';

  $log.debug('FooterController()');

  $scope.copyrightYear = (new Date()).getFullYear();

}]);
